// ════════════════════════════════════════════════════════════════════════════
//  Modo do app: "gestor" (ERP completo) ou "ponto" (Udisys Ponto standalone).
//  Definido em build por VITE_APP_MODE. O standalone reusa a MESMA base de código
//  e o mesmo backend (microserviço Fiscal / banco udisysponto), só recortando a UI
//  para o módulo de Ponto com marca própria. Tenant/licenciamento reusam a SaaS.
// ════════════════════════════════════════════════════════════════════════════

export const APP_MODE: string = (import.meta.env.VITE_APP_MODE as string | undefined) ?? "gestor";

/** True quando o build é o produto standalone "Udisys Ponto". */
export const isPontoStandalone = APP_MODE === "ponto";

/** Nome/tagline exibidos no shell conforme o modo. */
export const APP_NOME = isPontoStandalone ? "Udisys Ponto" : "Udisys Gestor";
export const APP_TAGLINE = isPontoStandalone ? "Controle de Ponto REP-P" : "Sistema de Gestão";

/** Rota inicial após o login conforme o modo. */
export const HOME_ROUTE = isPontoStandalone ? "/rh/ponto/meu" : "/";
